import { render } from "./Dialog.vue?vue&type=template&id=00b205b9"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"
script.render = render

export default script